import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { OrganizationSetting } from '@/types/organization';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = () => {};

type Response = Record<string, string>;

export const getCurrentOrganizationSettings = async (scope: RequestScope, options: ReadRequestOptions): Promise<EndpointResponse<Response>> => {
  try {
    validate();

    const result = await scopedApi(scope).get<EndpointResponse<OrganizationSetting[]>>('organization/setting', options);
    if (result.data.isError) return result.data;

    const settings = result.data.result || [];

    const settingsObject = settings.reduce((acc: Record<string, string>, setting: OrganizationSetting) => {
      acc[setting.name] = setting.value;
      return acc;
    }, {});

    return {
      ...result.data,
      result: settingsObject,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
